import {useLocation} from 'react-router-dom';
import type {BreadcrumbItem} from '@/components/breadcrumbs/Breadcrumbs';
import useCreatorProfileQuery from '@/hooks/queries/use-creator-profile-query';
import useBrandId from '@/hooks/use-brand-id';
import {matchBreadcrumbRoutes} from '../breadcrumbRouteTypes';
import {ALL_CAMPAIGN_BREADCRUMB_ROUTES} from '../breadcrumbRoutes';
import usePreservedSearchString from '../usePreservedSearchString';
import useContentSubmissionBreadcrumbData from './useContentSubmissionBreadcrumbData';

function useCampaignBreadcrumbItems(): BreadcrumbItem[] | null {
  const {pathname} = useLocation();
  const brandId = useBrandId();
  const preservedSearch = usePreservedSearchString();

  const matched = matchBreadcrumbRoutes(
    ALL_CAMPAIGN_BREADCRUMB_ROUTES,
    pathname
  );

  const {campaignId, creatorId, contentSubmissionId} = matched?.params ?? {};

  const {profile: creatorProfile} = useCreatorProfileQuery({
    profileId: creatorId ?? null,
    brandId,
    enabled: !!creatorId,
    include: [],
  });

  const sharedData = useContentSubmissionBreadcrumbData({
    campaignId,
    contentSubmissionId,
  });

  if (!matched) {
    return null;
  }

  const data = {
    ...sharedData,
    creatorName: creatorProfile?.displayName,
  };

  return matched.route
    .getItems(matched.params, data)
    .filter((item) => item.label)
    .map((item, i) =>
      i > 0 && item.link ? {...item, link: item.link + preservedSearch} : item
    );
}

export default useCampaignBreadcrumbItems;
